import normalizer from "@/apis/normalizer"
import { normalizerTypes } from "@/store/mutationTypes";

export default {
    namespaced: true,
    state: {
        all: [],
        fetchAll: {
            pending: false,
            error: null,
        },
        labelize: {
            pending: false,
            error: null,
        },
        deleteUnlabelled: {
            pending: false,
            error: null,
        },
        labelizationStatuses: {}
    },
    mutations: {
        [normalizerTypes.FETCH_ALL_REQUEST]: function (state) {
            state.fetchAll.pending = true
            state.fetchAll.error = null
        },
        [normalizerTypes.FETCH_ALL_SUCCESS]: function (state, all) {
            state.fetchAll.error = null
            state.fetchAll.pending = false
            state.all = all
        },
        [normalizerTypes.FETCH_ALL_FAILURE]: function (state, error) {
            state.fetchAll.error = error
            state.fetchAll.pending = false
        },
        [normalizerTypes.LABELIZE_REQUEST]: function (state) {
            state.labelize.pending = true
            state.labelize.error = null
        },
        [normalizerTypes.LABELIZE_SUCCESS]: function (state) {
            state.labelize.error = null
            state.labelize.pending = false
        },
        [normalizerTypes.LABELIZE_FAILURE]: function (state, error) {
            state.labelize.error = error
            state.labelize.pending = false
        },
        [normalizerTypes.DELETE_UNLABELLED_REQUEST]: function (state) {
            state.deleteUnlabelled.pending = true
            state.deleteUnlabelled.error = null
        },
        [normalizerTypes.DELETE_UNLABELLED_SUCCESS]: function (state) {
            state.deleteUnlabelled.error = null
            state.deleteUnlabelled.pending = false
        },
        [normalizerTypes.DELETE_UNLABELLED_FAILURE]: function (state, error) {
            state.deleteUnlabelled.error = error
            state.deleteUnlabelled.pending = false
        },
        [normalizerTypes.APPLY_STATUS]: function (state, payload) {
            if (!(payload.uuid in state.labelizationStatuses)) {
                state.labelizationStatuses[payload.uuid] = {}
            }
            state.labelizationStatuses[payload.uuid]["status"] = payload.status
            state.labelizationStatuses[payload.uuid]["pending"] = payload.pending
            state.labelizationStatuses = { ...state.labelizationStatuses }
        }
    },
    actions: {
        async fetchAll({ commit }) {
            commit(normalizerTypes.FETCH_ALL_REQUEST)
            return new Promise((resolve, reject) => {
                normalizer
                    .fetchAll()
                    .then(({ data }) => {
                        commit(normalizerTypes.FETCH_ALL_SUCCESS, data)
                        resolve(data)
                    })
                    .catch((error) => {
                        commit(normalizerTypes.FETCH_ALL_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async labelize({ commit }, payload) {
            commit(normalizerTypes.LABELIZE_REQUEST)
            commit(normalizerTypes.APPLY_STATUS, {
                uuid: payload.unlabelledUuid,
                status: "",
                pending: true,
            })
            return new Promise((resolve, reject) => {
                normalizer
                    .fetchAllKitchens(
                        payload.unlabelledUuid,
                        payload.itemUuid,
                        payload.itemType
                    )
                    .then(() => {
                        commit(normalizerTypes.LABELIZE_SUCCESS)
                        commit(normalizerTypes.APPLY_STATUS, {
                            uuid: payload.unlabelledUuid,
                            status: "labelized",
                            pending: false,
                        })
                        resolve()
                    })
                    .catch((error) => {
                        commit(normalizerTypes.LABELIZE_FAILURE, error)
                        commit(normalizerTypes.APPLY_STATUS, {
                            uuid: payload.unlabelledUuid,
                            status: "",
                            pending: false,
                        })
                        reject(error)
                    })
            })
        },
        async deleteUnlabelled({ commit }, payload) {
            commit(normalizerTypes.DELETE_UNLABELLED_REQUEST)
            commit(normalizerTypes.APPLY_STATUS, payload.uuid, "", true)
            return new Promise((resolve, reject) => {
                commit(normalizerTypes.APPLY_STATUS, {
                    uuid: payload.uuid,
                    status: "deleted",
                    pending: false,
                })
                resolve();
                reject
                normalizer
                    .deleteUnlabelled(payload.uuid)
                    .then(() => {
                        commit(normalizerTypes.DELETE_UNLABELLED_SUCCESS)
                        commit(normalizerTypes.APPLY_STATUS, {
                            uuid: payload.uuid,
                            status: "deleted",
                            pending: false,
                        })
                        resolve()
                    })
                    .catch((error) => {
                        commit(normalizerTypes.DELETE_UNLABELLED_FAILURE, error)
                        commit(normalizerTypes.APPLY_STATUS, {
                            uuid: payload.uuid,
                            status: "",
                            pending: false,
                        })
                        reject(error)
                    })
            })
        },
    }
}
